import { render, staticRenderFns } from "./userd.vue?vue&type=template&id=c0b0ba56&scoped=true&"
import script from "./userd.vue?vue&type=script&lang=js&"
export * from "./userd.vue?vue&type=script&lang=js&"
import style0 from "./userd.vue?vue&type=style&index=0&id=c0b0ba56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b0ba56",
  null
  
)

component.options.__file = "userd.vue"
export default component.exports